<template>
  <div class="main">
    <div class="menu">
      <main-menu />
    </div>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import MainMenu from "./MainMenu.vue";
export default {
  components: {
    MainMenu
  }
};
</script>

<style lang="less">
html,
body {
  overflow: auto;
}
.main {
  display: flex;
  height: 100vh;
  .menu {
    flex: 0 0 270px;
    background-color: #0a252c;
  }
  .content {
    flex: 1 1 auto;
    box-sizing: border-box;
    padding: 20px;
    background-color: #f5f5f5;
    overflow-y: auto;
  }
}
</style>